<template>
  <div
    @click="$emit('click')"
    style="cursor: pointer; display: inline-block; margin-top: 1px; margin-right: 5px;"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 512 512"
    >
      <g
        :stroke="isDarkTheme ? headingTextColor : '#ffffff'"
        :fill="isDarkTheme ? headingTextColor : '#ffffff'"
        stroke-width="20"
        fill="none"
      >
        <rect
          x="20"
          y="70"
          width="472"
          height="372"
          rx="50"
          ry="50"
          stroke-linejoin="round"
        />
        <path
          d="M492 185H380c-38.66 0-70 31.34-70 70s31.34 70 70 70h112"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <ellipse
          cx="385"
          cy="255"
          rx="18"
          ry="18"
          fill="currentColor"
          stroke="none"
          :style="{ fill: headingTextColor || '#000000' }"
        />
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  name: "WalletIcon",
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    headingTextColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null;
    }
  }
};
</script>
<style scoped>
div:hover {
  opacity: 0.7;
  transition: opacity 0.2s;
}
</style>
